import { Component, ErrorInfo, ReactNode } from 'react';
import CustomErrorPage from './routes/CustomErrorPage';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    console.error("[ERROR]: ", error.stack);
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return <CustomErrorPage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
